import React, { Component } from 'react';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, TreeSelect } from 'antd';

import './profile.css';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
const Panel = Collapse.Panel;
const TreeNode = TreeSelect.TreeNode;


class ScoutingInfo extends Component {

    state = {
        // value: "type here!",
        isInEditMode: false,
        value: undefined,
          
    }

    // onChange is for multiselect

    onChangeMultiselect = value => {
        console.log(value);
        this.setState({ value });
      };

    changeEditMode = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode
        })
    }

    updateComponentValue = () => {
        this.setState({
            isInEditMode: false,
            // value: this.refs.theTextInput.value
        })
    }

    renderEditView = () => {
        const Option = Select.Option;
        const FormItem = Form.Item;
        const dateFormat = 'MM/DD/YYYY';

        const selectBefore = (
            <Select defaultValue="Prefix" className="dropdown-blue" >
                <Option value="mr">Mr</Option>
                <Option value="mrs">Mrs</Option>
            </Select>
        );
        const selectAfter = (
            <Select defaultValue="Suffix" className="dropdown-blue">
                <Option value="mr">Mr</Option>
                <Option value="mrs">Mrs</Option>
            </Select>
        );
        return (<div className='container'>
            <Collapse defaultActiveKey={['1']} accordion bordered={false} >
                <Panel key="1" header={<div> <span className="myProfile-collapse-header">Scouting Information </span> <span style={{ fontSize: '12px', color: 'grey', fontWeight: 300, marginLeft: '14px' }}>Edting...</span> </div>}>
                    <Form className='myprofile-form' style={{display:'block'}}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                            <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Unit Type You Most Identify with as a Youth Member"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Select a Type"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="pack">Pack</Option>
                                            <Option value="troop">Troop</Option>
                                            <Option value="team">Team</Option>
                                            <Option value="crew">Crew</Option>
                                            <Option value="ship">Ship</Option>
                                            <Option value="post">Post</Option>
                                            <Option value="lone">Lone Scout</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Unit Number You Most Identify with as a Youth Member"
                                    >
                                        <Input placeholder="Unit Number You Most Identify with as a Youth Member" />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Unit City You Most Identify with as a Youth Member"
                                    >
                                        <Input placeholder="Unit City You Most Identify with as a Youth Member" />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Unit State You Most Identify with as a Youth Member"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Select a State"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="AL">AL</Option>
                                            <Option value="AK">AK</Option>
                                            <Option value="AS">AS</Option>
                                            <Option value="AZ">AZ</Option>
                                            <Option value="AR">AR</Option>
                                            <Option value="AA">AA</Option>
                                            <Option value="AE">AE</Option>
                                            <Option value="AP">AP</Option>
                                            <Option value="CA">CA</Option>
                                            <Option value="CO">CO</Option>
                                            <Option value="CT">CT</Option>
                                            <Option value="DE">DE</Option>
                                            <Option value="DC">DC</Option>
                                            <Option value="FM">FM</Option>
                                            <Option value="FL">FL</Option>
                                            <Option value="GA">GA</Option>
                                            <Option value="GU">GU</Option>
                                            <Option value="HI">HI</Option>
                                            <Option value="ID">ID</Option>
                                            <Option value="IL">IL</Option>
                                            <Option value="IN">IN</Option>
                                            <Option value="IA">IA</Option>
                                            <Option value="KS">KS</Option>
                                            <Option value="KY">KY</Option>
                                            <Option value="LA">LA</Option>
                                            <Option value="ME">ME</Option>
                                            <Option value="MH">MH</Option>
                                            <Option value="MD">MD</Option>
                                            <Option value="MA">MA</Option>
                                            <Option value="MI">MI</Option>
                                            <Option value="MN">MN</Option>
                                            <Option value="MS">MS</Option>
                                            <Option value="MO">MO</Option>
                                            <Option value="MT">MT</Option>
                                            <Option value="NE">NE</Option>
                                            <Option value="NV">NV</Option>
                                            <Option value="NH">NH</Option>
                                            <Option value="NJ">NJ</Option>
                                            <Option value="NM">NM</Option>
                                            <Option value="NY">NY</Option>
                                            <Option value="NC">NC</Option>
                                            <Option value="ND">ND</Option>
                                            <Option value="MP">MP</Option>
                                            <Option value="OH">OH</Option>
                                            <Option value="OK">OK</Option>
                                            <Option value="OR">OR</Option>
                                            <Option value="PW">PW</Option>
                                            <Option value="PA">PA</Option>
                                            <Option value="PR">PR</Option>
                                            <Option value="RI">RI</Option>
                                            <Option value="SC">SC</Option>
                                            <Option value="SD">SD</Option>
                                            <Option value="TN">TN</Option>
                                            <Option value="TX">TX</Option>
                                            <Option value="UT">UT</Option>
                                            <Option value="VT">VT</Option>
                                            <Option value="VA">VA</Option>
                                            <Option value="VI">VI</Option>
                                            <Option value="WA">WA</Option>
                                            <Option value="WV">WV</Option>
                                            <Option value="WI">WI</Option>
                                            <Option value="WY">WY</Option>
                                            <Option value="NotUSA">Not in USA</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Current Council"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Select Current Council"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="WY">Abraham Lincoln (144)</Option>
                                            <Option value="WY">Alabama-Florida (003)</Option>
                                            <Option value="WY">Alameda (022)</Option>
                                            <Option value="WY">Alamo Area (583)</Option>
                                            <Option value="WY">Allegheny Highlands (382)</Option>
                                            <Option value="WY">Allohak (618)</Option>
                                            <Option value="WY">Aloha (104)</Option>
                                            <Option value="WY">Andrew Jackson (303)</Option>
                                            <Option value="WY">Anthony Wayne Area (157)</Option>
                                            <Option value="WY">Arbuckle Area (468)</Option>
                                            <Option value="WY">Atlanta Area (092)</Option>
                                            <Option value="WY">Baden-Powell (368)</Option>
                                            <Option value="WY">Baltimore Area (220)</Option>
                                            <Option value="WY">Bay Area (574)</Option>
                                            <Option value="WY">Bay-Lakes (635)</Option>
                                            <Option value="WY">Black Hills Area (695)</Option>
                                            <Option value="WY">Black Swamp Area (449)</Option>
                                            <Option value="WY">Black Warrior (006)</Option>
                                            <Option value="WY">Blackhawk Area (660)</Option>
                                            <Option value="WY">Blue Grass (204)</Option>
                                            <Option value="WY">Blue Mountain (604)</Option>
                                            <Option value="WY">Blue Ridge (551)</Option>
                                            <Option value="WY">Blue Ridge Mountains (599)</Option>
                                            <Option value="WY">Buckeye (436)</Option>
                                            <Option value="WY">Buckskin (617)</Option>
                                            <Option value="WY">Bucktail (509)</Option>
                                            <Option value="WY">Buffalo Trace (156)</Option>
                                            <Option value="WY">Buffalo Trail (567)</Option>
                                            <Option value="WY">Caddo Area (584)</Option>
                                            <Option value="WY">Calcasieu Area (209)</Option>
                                            <Option value="WY">California Inland Empire (045)</Option>
                                            <Option value="WY">Cape Cod and Islands (224)</Option>
                                            <Option value="WY">Cape Fear (425)</Option>
                                            <Option value="WY">Capitol Area (564)</Option>
                                            <Option value="WY">Cascade Pacific (492)</Option>
                                            <Option value="WY">Catalina (011)</Option>
                                            <Option value="WY">Central Florida (083)</Option>
                                            <Option value="WY">Central Georgia (096)</Option>
                                            <Option value="WY">Central Minnesota (296)</Option>
                                            <Option value="WY">Central North Carolina (416)</Option>
                                            <Option value="WY">Chattahoochee (091)</Option>
                                            <Option value="WY">Cherokee Area (469)</Option>
                                            <Option value="WY">Cherokee Area (556)</Option>
                                            <Option value="WY">Chester County (539)</Option>
                                            <Option value="WY">Chickasaw (558)</Option>
                                            <Option value="WY">Chief Cornplanter (538)</Option>
                                            <Option value="WY">Chief Seattle (609)</Option>
                                            <Option value="WY">Chippewa Valley (637)</Option>
                                            <Option value="WY">Choctaw Area (302)</Option>
                                            <Option value="WY">Cimarron (474)</Option>
                                            <Option value="WY">Circle Ten (571)</Option>
                                            <Option value="WY">Coastal Carolina (550)</Option>
                                            <Option value="WY">Coastal Georgia (099)</Option>
                                            <Option value="WY">Colonial Virginia (595)</Option>
                                            <Option value="WY">Columbia-Montour (504)</Option>
                                            <Option value="WY">Connecticut Rivers (066)</Option>
                                            <Option value="WY">Connecticut Yankee (072)</Option>
                                            <Option value="WY">Conquistador (413)</Option>
                                            <Option value="WY">Cornhusker (324)</Option>
                                            <Option value="WY">Coronado Area (192)</Option>
                                            <Option value="WY">Cradle of Liberty (525)</Option>
                                            <Option value="WY">Crater Lake (491)</Option>
                                            <Option value="WY">Crossroads of America (160)</Option>
                                            <Option value="WY">Dan Beard (438)</Option>
                                            <Option value="WY">Daniel Boone (414)</Option>
                                            <Option value="WY">Daniel Webster (330)</Option>
                                            <Option value="WY">De Soto Area (013)</Option>
                                            <Option value="WY">Del-Mar-Va (081)</Option>
                                            <Option value="WY">Denver Area (061)</Option>
                                            <Option value="WY">Direct Service (800)</Option>
                                            <Option value="WY">East Carolina (426)</Option>
                                            <Option value="WY">East Texas Area (585)</Option>
                                            <Option value="WY">Erie Shores (460)</Option>
                                            <Option value="WY">Evangeline Area (212)</Option>
                                            <Option value="WY">Far East (803)</Option>
                                            <Option value="WY">Five Rivers (375)</Option>
                                            <Option value="WY">Flint River (095)</Option>
                                            <Option value="WY">French Creek (532)</Option>
                                            <Option value="WY">Gamehaven (299)</Option>
                                            <Option value="WY">Garden State (690)</Option>
                                            <Option value="WY">Gateway Area (624)</Option>
                                            <Option value="WY">Georgia-Carolina (093)</Option>
                                            <Option value="WY">Glacier's Edge (620)</Option>
                                            <Option value="WY">Golden Empire (047)</Option>
                                            <Option value="WY">Golden Spread (562)</Option>
                                            <Option value="WY">Grand Canyon (010)</Option>
                                            <Option value="WY">Grand Columbia (614)</Option>
                                            <Option value="WY">Grand Teton (107)</Option>
                                            <Option value="WY">Great Alaska (610)</Option>
                                            <Option value="WY">Great Lakes FSC (272)</Option>
                                            <Option value="WY">Great Rivers (653)</Option>
                                            <Option value="WY">Great Salt Lake (590)</Option>
                                            <Option value="WY">Great Smoky Mountain (557)</Option>
                                            <Option value="WY">Great Southwest (412)</Option>
                                            <Option value="WY">Great Trail (433)</Option>
                                            <Option value="WY">Greater Alabama (001)</Option>
                                            <Option value="WY">Greater Los Angeles Area (033)</Option>
                                            <Option value="WY">Greater New York Councils (640)</Option>
                                            <Option value="WY">Greater Niagara Frontier (380)</Option>
                                            <Option value="WY">Greater St. Louis Area (312)</Option>
                                            <Option value="WY">Greater Tampa Bay Area (089)</Option>
                                            <Option value="WY">Greater Wyoming (638)</Option>
                                            <Option value="WY">Greater Yosemite (059)</Option>
                                            <Option value="WY">Green Mountain (592)</Option>
                                            <Option value="WY">Greenwich (067)</Option>
                                            <Option value="WY">Gulf Coast (773)</Option>
                                            <Option value="WY">Gulf Stream (085)</Option>
                                            <Option value="WY">Hawk Mountain (528)</Option>
                                            <Option value="WY">Hawkeye Area (172)</Option>
                                            <Option value="WY">Heart of America (307)</Option>
                                            <Option value="WY">Heart of Virginia (602)</Option>
                                            <Option value="WY">Hoosier Trails (145)</Option>
                                            <Option value="WY">Housatonic (069)</Option>
                                            <Option value="WY">Hudson Valley (374)</Option>
                                            <Option value="WY">Illowa (133)</Option>
                                            <Option value="WY">Indian Nations (488)</Option>
                                            <Option value="WY">Indian Waters (553)</Option>
                                            <Option value="WY">Inland Northwest (611)</Option>
                                            <Option value="WY">Iroquois Trail (376)</Option>
                                            <Option value="WY">Istrouma Area (211)</Option>
                                            <Option value="WY">Jayhawk Area (197)</Option>
                                            <Option value="WY">Jersey Shore (341)</Option>
                                            <Option value="WY">Juniata Valley (497)</Option>
                                            <Option value="WY">Katahdin Area (216)</Option>
                                            <Option value="WY">La Salle (165)</Option>
                                            <Option value="WY">Lake Erie (440)</Option>
                                            <Option value="WY">Las Vegas Area (328)</Option>
                                            <Option value="WY">Last Frontier (480)</Option>
                                            <Option value="WY">Laurel Highlands (527)</Option>
                                            <Option value="WY">Leatherstocking (400)</Option>
                                            <Option value="WY">Lincoln Heritage (205)</Option>
                                            <Option value="WY">Lincoln Trails (121)</Option>
                                            <Option value="WY">Long Beach Area (032)</Option>
                                            <Option value="WY">Longhorn (662)</Option>
                                            <Option value="WY">Longhouse (373)</Option>
                                            <Option value="WY">Longs Peak (062)</Option>
                                            <Option value="WY">Los Padres (053)</Option>
                                            <Option value="WY">Louisiana Purchase (213)</Option>
                                            <Option value="WY">Marin (035)</Option>
                                            <Option value="WY">Mason-Dixon (221)</Option>
                                            <Option value="WY">Maui County (102)</Option>
                                            <Option value="WY">Mayflower (251)</Option>
                                            <Option value="WY">Mecklenburg County (415)</Option>
                                            <Option value="WY">Miami Valley (444)</Option>
                                            <Option value="WY">Michigan Crossroads (780)</Option>
                                            <Option value="WY">Mid-America (326)</Option>
                                            <Option value="WY">Middle Tennessee (560)</Option>
                                            <Option value="WY">Mid-Iowa (177)</Option>
                                            <Option value="WY">Midnight Sun (696)</Option>
                                            <Option value="WY">Minsi Trails (502)</Option>
                                            <Option value="WY">Mississippi Valley (141)</Option>
                                            <Option value="WY">Mobile Area (004)</Option>
                                            <Option value="WY">Mohegan (254)</Option>
                                            <Option value="WY">Monmouth (347)</Option>
                                            <Option value="WY">Montana (315)</Option>
                                            <Option value="WY">Moraine Trails (500)</Option>
                                            <Option value="WY">Mount Baker (606)</Option>
                                            <Option value="WY">Mount Diablo Silverado (023)</Option>
                                            <Option value="WY">Mountaineer Area (615)</Option>
                                            <Option value="WY">Muskingum Valley (467)</Option>
                                            <Option value="WY">Narragansett (546)</Option>
                                            <Option value="WY">Nashua Valley (230)</Option>
                                            <Option value="WY">National Capital Area (082)</Option>
                                            <Option value="WY">National Council (000)</Option>
                                            <Option value="WY">Nevada Area (329)</Option>
                                            <Option value="WY">New Birth of Freedom (544)</Option>
                                            <Option value="WY">North Florida (087)</Option>
                                            <Option value="WY">Northeast Georgia (101)</Option>
                                            <Option value="WY">Northeast Illinois (129)</Option>
                                            <Option value="WY">Northeast Iowa (178)</Option>
                                            <Option value="WY">Northeastern Pennsylvania (501)</Option>
                                            <Option value="WY">Northern Lights (429)</Option>
                                            <Option value="WY">Northern New Jersey (333)</Option>
                                            <Option value="WY">Northern Star (250)</Option>
                                            <Option value="WY">Northwest Georgia (100)</Option>
                                            <Option value="WY">Northwest Texas (587)</Option>
                                            <Option value="WY">Norwela (215)</Option>
                                            <Option value="WY">Occoneechee (421)</Option>
                                            <Option value="WY">Ohio River Valley (619)</Option>
                                            <Option value="WY">Old Hickory (427)</Option>
                                            <Option value="WY">Old North State (070)</Option>
                                            <Option value="WY">Orange County (039)</Option>
                                            <Option value="WY">Oregon Trail (697)</Option>
                                            <Option value="WY">Ore-Ida (106)</Option>
                                            <Option value="WY">Overland Trails (322)</Option>
                                            <Option value="WY">Ozark Trails (306)</Option>
                                            <Option value="WY">Pacific Harbors (612)</Option>
                                            <Option value="WY">Pacific Skyline (031)</Option>
                                            <Option value="WY">Palmetto (549)</Option>
                                            <Option value="WY">Pathway to Adventure (456)</Option>
                                            <Option value="WY">Patriots' Path (358)</Option>
                                            <Option value="WY">Pee Dee Area (552)</Option>
                                            <Option value="WY">Pennsylvania Dutch (524)</Option>
                                            <Option value="WY">Piedmont (042)</Option>
                                            <Option value="WY">Piedmont (420)</Option>
                                            <Option value="WY">Pikes Peak (060)</Option>
                                            <Option value="WY">Pine Burr Area (304)</Option>
                                            <Option value="WY">Pine Tree (218)</Option>
                                            <Option value="WY">Pony Express (311)</Option>
                                            <Option value="WY">Potawatomi Area (651)</Option>
                                            <Option value="WY">Prairielands (117)</Option>
                                            <Option value="WY">President Gerald R. Ford FSC (781)</Option>
                                            <Option value="WY">Puerto Rico (661)</Option>
                                            <Option value="WY">Pushmataha Area (691)</Option>
                                            <Option value="WY">Quapaw Area (018)</Option>
                                            <Option value="WY">Quivira (198)</Option>
                                            <Option value="WY">Rainbow (702)</Option>
                                            <Option value="WY">Redwood Empire (041)</Option>
                                            <Option value="WY">Rio Grande (775)</Option>
                                            <Option value="WY">Rip Van Winkle (405)</Option>
                                            <Option value="WY">Rocky Mountain (063)</Option>
                                            <Option value="WY">Sagamore (162)</Option>
                                            <Option value="WY">Sam Houston Area (576)</Option>
                                            <Option value="WY">Samoset (627)</Option>
                                            <Option value="WY">San Diego-Imperial (049)</Option>
                                            <Option value="WY">San Francisco Bay Area (028)</Option>
                                            <Option value="WY">Santa Fe Trail (194)</Option>
                                            <Option value="WY">Seneca Waterways (397)</Option>
                                            <Option value="WY">Sequoia (027)</Option>
                                            <Option value="WY">Sequoyah (713)</Option>
                                            <Option value="WY">Shenandoah Area (598)</Option>
                                            <Option value="WY">Silicon Valley Monterey Bay (055)</Option>
                                            <Option value="WY">Simon Kenton (441)</Option>
                                            <Option value="WY">Sioux (733)</Option>
                                            <Option value="WY">Snake River (111)</Option>
                                            <Option value="WY">South Florida (084)</Option>
                                            <Option value="WY">South Georgia (098)</Option>
                                            <Option value="WY">South Plains (694)</Option>
                                            <Option value="WY">South Texas (577)</Option>
                                            <Option value="WY">Southeast Louisiana (214)</Option>
                                            <Option value="WY">Southern Shores FSC (783)</Option>
                                            <Option value="WY">Southern Sierra (030)</Option>
                                            <Option value="WY">Southwest Florida (088)</Option>
                                            <Option value="WY">Stonewall Jackson Area (763)</Option>
                                            <Option value="WY">Suffolk County (404)</Option>
                                            <Option value="WY">Susquehanna (533)</Option>
                                            <Option value="WY">Suwannee River Area (664)</Option>
                                            <Option value="WY">Tecumseh (439)</Option>
                                            <Option value="WY">Texas Southwest (741)</Option>
                                            <Option value="WY">Texas Trails (561)</Option>
                                            <Option value="WY">The Spirit of Adventure (227)</Option>
                                            <Option value="WY">Theodore Roosevelt (386)</Option>
                                            <Option value="WY">Three Fires (127)</Option>
                                            <Option value="WY">Three Harbors (636)</Option>
                                            <Option value="WY">Three Rivers (578)</Option>
                                            <Option value="WY">Tidewater (596)</Option>
                                            <Option value="WY">Transatlantic (802)</Option>
                                            <Option value="WY">Trapper Trails (589)</Option>
                                            <Option value="WY">Tukabatchee Area (005)</Option>
                                            <Option value="WY">Tuscarora (424)</Option>
                                            <Option value="WY">Twin Rivers (364)</Option>
                                            <Option value="WY">Twin Valley (283)</Option>
                                            <Option value="WY">Utah National Parks (591)</Option>
                                            <Option value="WY">Ventura County (057)</Option>
                                            <Option value="WY">Verdugo Hills (058)</Option>
                                            <Option value="WY">Voyageurs Area (286)</Option>
                                            <Option value="WY">W.D. Boyce (138)</Option>
                                            <Option value="WY">Washington Crossing (777)</Option>
                                            <Option value="WY">Water and Woods FSC (782)</Option>
                                            <Option value="WY">West Tennessee Area (559)</Option>
                                            <Option value="WY">Westark Area (016)</Option>
                                            <Option value="WY">Westchester-Putnam (388)</Option>
                                            <Option value="WY">Western Colorado (064)</Option>
                                            <Option value="WY">Western Los Angeles County (051)</Option>
                                            <Option value="WY">Western Massachusetts (234)</Option>
                                            <Option value="WY">Westmoreland-Fayette (512)</Option>
                                            <Option value="WY">Winnebago (173)</Option>
                                            <Option value="WY">Yocona Area (748)</Option>
                                            <Option value="WY">Yucca (573)</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Other Council Affiliations"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Select Other Council Affiliations"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            											<Option value="WY">Abraham Lincoln (144)</Option>
                                            <Option value="WY">Alabama-Florida (003)</Option>
                                            <Option value="WY">Alameda (022)</Option>
                                            <Option value="WY">Alamo Area (583)</Option>
                                            <Option value="WY">Allegheny Highlands (382)</Option>
                                            <Option value="WY">Allohak (618)</Option>
                                            <Option value="WY">Aloha (104)</Option>
                                            <Option value="WY">Andrew Jackson (303)</Option>
                                            <Option value="WY">Anthony Wayne Area (157)</Option>
                                            <Option value="WY">Arbuckle Area (468)</Option>
                                            <Option value="WY">Atlanta Area (092)</Option>
                                            <Option value="WY">Baden-Powell (368)</Option>
                                            <Option value="WY">Baltimore Area (220)</Option>
                                            <Option value="WY">Bay Area (574)</Option>
                                            <Option value="WY">Bay-Lakes (635)</Option>
                                            <Option value="WY">Black Hills Area (695)</Option>
                                            <Option value="WY">Black Swamp Area (449)</Option>
                                            <Option value="WY">Black Warrior (006)</Option>
                                            <Option value="WY">Blackhawk Area (660)</Option>
                                            <Option value="WY">Blue Grass (204)</Option>
                                            <Option value="WY">Blue Mountain (604)</Option>
                                            <Option value="WY">Blue Ridge (551)</Option>
                                            <Option value="WY">Blue Ridge Mountains (599)</Option>
                                            <Option value="WY">Buckeye (436)</Option>
                                            <Option value="WY">Buckskin (617)</Option>
                                            <Option value="WY">Bucktail (509)</Option>
                                            <Option value="WY">Buffalo Trace (156)</Option>
                                            <Option value="WY">Buffalo Trail (567)</Option>
                                            <Option value="WY">Caddo Area (584)</Option>
                                            <Option value="WY">Calcasieu Area (209)</Option>
                                            <Option value="WY">California Inland Empire (045)</Option>
                                            <Option value="WY">Cape Cod and Islands (224)</Option>
                                            <Option value="WY">Cape Fear (425)</Option>
                                            <Option value="WY">Capitol Area (564)</Option>
                                            <Option value="WY">Cascade Pacific (492)</Option>
                                            <Option value="WY">Catalina (011)</Option>
                                            <Option value="WY">Central Florida (083)</Option>
                                            <Option value="WY">Central Georgia (096)</Option>
                                            <Option value="WY">Central Minnesota (296)</Option>
                                            <Option value="WY">Central North Carolina (416)</Option>
                                            <Option value="WY">Chattahoochee (091)</Option>
                                            <Option value="WY">Cherokee Area (469)</Option>
                                            <Option value="WY">Cherokee Area (556)</Option>
                                            <Option value="WY">Chester County (539)</Option>
                                            <Option value="WY">Chickasaw (558)</Option>
                                            <Option value="WY">Chief Cornplanter (538)</Option>
                                            <Option value="WY">Chief Seattle (609)</Option>
                                            <Option value="WY">Chippewa Valley (637)</Option>
                                            <Option value="WY">Choctaw Area (302)</Option>
                                            <Option value="WY">Cimarron (474)</Option>
                                            <Option value="WY">Circle Ten (571)</Option>
                                            <Option value="WY">Coastal Carolina (550)</Option>
                                            <Option value="WY">Coastal Georgia (099)</Option>
                                            <Option value="WY">Colonial Virginia (595)</Option>
                                            <Option value="WY">Columbia-Montour (504)</Option>
                                            <Option value="WY">Connecticut Rivers (066)</Option>
                                            <Option value="WY">Connecticut Yankee (072)</Option>
                                            <Option value="WY">Conquistador (413)</Option>
                                            <Option value="WY">Cornhusker (324)</Option>
                                            <Option value="WY">Coronado Area (192)</Option>
                                            <Option value="WY">Cradle of Liberty (525)</Option>
                                            <Option value="WY">Crater Lake (491)</Option>
                                            <Option value="WY">Crossroads of America (160)</Option>
                                            <Option value="WY">Dan Beard (438)</Option>
                                            <Option value="WY">Daniel Boone (414)</Option>
                                            <Option value="WY">Daniel Webster (330)</Option>
                                            <Option value="WY">De Soto Area (013)</Option>
                                            <Option value="WY">Del-Mar-Va (081)</Option>
                                            <Option value="WY">Denver Area (061)</Option>
                                            <Option value="WY">Direct Service (800)</Option>
                                            <Option value="WY">East Carolina (426)</Option>
                                            <Option value="WY">East Texas Area (585)</Option>
                                            <Option value="WY">Erie Shores (460)</Option>
                                            <Option value="WY">Evangeline Area (212)</Option>
                                            <Option value="WY">Far East (803)</Option>
                                            <Option value="WY">Five Rivers (375)</Option>
                                            <Option value="WY">Flint River (095)</Option>
                                            <Option value="WY">French Creek (532)</Option>
                                            <Option value="WY">Gamehaven (299)</Option>
                                            <Option value="WY">Garden State (690)</Option>
                                            <Option value="WY">Gateway Area (624)</Option>
                                            <Option value="WY">Georgia-Carolina (093)</Option>
                                            <Option value="WY">Glacier's Edge (620)</Option>
                                            <Option value="WY">Golden Empire (047)</Option>
                                            <Option value="WY">Golden Spread (562)</Option>
                                            <Option value="WY">Grand Canyon (010)</Option>
                                            <Option value="WY">Grand Columbia (614)</Option>
                                            <Option value="WY">Grand Teton (107)</Option>
                                            <Option value="WY">Great Alaska (610)</Option>
                                            <Option value="WY">Great Lakes FSC (272)</Option>
                                            <Option value="WY">Great Rivers (653)</Option>
                                            <Option value="WY">Great Salt Lake (590)</Option>
                                            <Option value="WY">Great Smoky Mountain (557)</Option>
                                            <Option value="WY">Great Southwest (412)</Option>
                                            <Option value="WY">Great Trail (433)</Option>
                                            <Option value="WY">Greater Alabama (001)</Option>
                                            <Option value="WY">Greater Los Angeles Area (033)</Option>
                                            <Option value="WY">Greater New York Councils (640)</Option>
                                            <Option value="WY">Greater Niagara Frontier (380)</Option>
                                            <Option value="WY">Greater St. Louis Area (312)</Option>
                                            <Option value="WY">Greater Tampa Bay Area (089)</Option>
                                            <Option value="WY">Greater Wyoming (638)</Option>
                                            <Option value="WY">Greater Yosemite (059)</Option>
                                            <Option value="WY">Green Mountain (592)</Option>
                                            <Option value="WY">Greenwich (067)</Option>
                                            <Option value="WY">Gulf Coast (773)</Option>
                                            <Option value="WY">Gulf Stream (085)</Option>
                                            <Option value="WY">Hawk Mountain (528)</Option>
                                            <Option value="WY">Hawkeye Area (172)</Option>
                                            <Option value="WY">Heart of America (307)</Option>
                                            <Option value="WY">Heart of Virginia (602)</Option>
                                            <Option value="WY">Hoosier Trails (145)</Option>
                                            <Option value="WY">Housatonic (069)</Option>
                                            <Option value="WY">Hudson Valley (374)</Option>
                                            <Option value="WY">Illowa (133)</Option>
                                            <Option value="WY">Indian Nations (488)</Option>
                                            <Option value="WY">Indian Waters (553)</Option>
                                            <Option value="WY">Inland Northwest (611)</Option>
                                            <Option value="WY">Iroquois Trail (376)</Option>
                                            <Option value="WY">Istrouma Area (211)</Option>
                                            <Option value="WY">Jayhawk Area (197)</Option>
                                            <Option value="WY">Jersey Shore (341)</Option>
                                            <Option value="WY">Juniata Valley (497)</Option>
                                            <Option value="WY">Katahdin Area (216)</Option>
                                            <Option value="WY">La Salle (165)</Option>
                                            <Option value="WY">Lake Erie (440)</Option>
                                            <Option value="WY">Las Vegas Area (328)</Option>
                                            <Option value="WY">Last Frontier (480)</Option>
                                            <Option value="WY">Laurel Highlands (527)</Option>
                                            <Option value="WY">Leatherstocking (400)</Option>
                                            <Option value="WY">Lincoln Heritage (205)</Option>
                                            <Option value="WY">Lincoln Trails (121)</Option>
                                            <Option value="WY">Long Beach Area (032)</Option>
                                            <Option value="WY">Longhorn (662)</Option>
                                            <Option value="WY">Longhouse (373)</Option>
                                            <Option value="WY">Longs Peak (062)</Option>
                                            <Option value="WY">Los Padres (053)</Option>
                                            <Option value="WY">Louisiana Purchase (213)</Option>
                                            <Option value="WY">Marin (035)</Option>
                                            <Option value="WY">Mason-Dixon (221)</Option>
                                            <Option value="WY">Maui County (102)</Option>
                                            <Option value="WY">Mayflower (251)</Option>
                                            <Option value="WY">Mecklenburg County (415)</Option>
                                            <Option value="WY">Miami Valley (444)</Option>
                                            <Option value="WY">Michigan Crossroads (780)</Option>
                                            <Option value="WY">Mid-America (326)</Option>
                                            <Option value="WY">Middle Tennessee (560)</Option>
                                            <Option value="WY">Mid-Iowa (177)</Option>
                                            <Option value="WY">Midnight Sun (696)</Option>
                                            <Option value="WY">Minsi Trails (502)</Option>
                                            <Option value="WY">Mississippi Valley (141)</Option>
                                            <Option value="WY">Mobile Area (004)</Option>
                                            <Option value="WY">Mohegan (254)</Option>
                                            <Option value="WY">Monmouth (347)</Option>
                                            <Option value="WY">Montana (315)</Option>
                                            <Option value="WY">Moraine Trails (500)</Option>
                                            <Option value="WY">Mount Baker (606)</Option>
                                            <Option value="WY">Mount Diablo Silverado (023)</Option>
                                            <Option value="WY">Mountaineer Area (615)</Option>
                                            <Option value="WY">Muskingum Valley (467)</Option>
                                            <Option value="WY">Narragansett (546)</Option>
                                            <Option value="WY">Nashua Valley (230)</Option>
                                            <Option value="WY">National Capital Area (082)</Option>
                                            <Option value="WY">National Council (000)</Option>
                                            <Option value="WY">Nevada Area (329)</Option>
                                            <Option value="WY">New Birth of Freedom (544)</Option>
                                            <Option value="WY">North Florida (087)</Option>
                                            <Option value="WY">Northeast Georgia (101)</Option>
                                            <Option value="WY">Northeast Illinois (129)</Option>
                                            <Option value="WY">Northeast Iowa (178)</Option>
                                            <Option value="WY">Northeastern Pennsylvania (501)</Option>
                                            <Option value="WY">Northern Lights (429)</Option>
                                            <Option value="WY">Northern New Jersey (333)</Option>
                                            <Option value="WY">Northern Star (250)</Option>
                                            <Option value="WY">Northwest Georgia (100)</Option>
                                            <Option value="WY">Northwest Texas (587)</Option>
                                            <Option value="WY">Norwela (215)</Option>
                                            <Option value="WY">Occoneechee (421)</Option>
                                            <Option value="WY">Ohio River Valley (619)</Option>
                                            <Option value="WY">Old Hickory (427)</Option>
                                            <Option value="WY">Old North State (070)</Option>
                                            <Option value="WY">Orange County (039)</Option>
                                            <Option value="WY">Oregon Trail (697)</Option>
                                            <Option value="WY">Ore-Ida (106)</Option>
                                            <Option value="WY">Overland Trails (322)</Option>
                                            <Option value="WY">Ozark Trails (306)</Option>
                                            <Option value="WY">Pacific Harbors (612)</Option>
                                            <Option value="WY">Pacific Skyline (031)</Option>
                                            <Option value="WY">Palmetto (549)</Option>
                                            <Option value="WY">Pathway to Adventure (456)</Option>
                                            <Option value="WY">Patriots' Path (358)</Option>
                                            <Option value="WY">Pee Dee Area (552)</Option>
                                            <Option value="WY">Pennsylvania Dutch (524)</Option>
                                            <Option value="WY">Piedmont (042)</Option>
                                            <Option value="WY">Piedmont (420)</Option>
                                            <Option value="WY">Pikes Peak (060)</Option>
                                            <Option value="WY">Pine Burr Area (304)</Option>
                                            <Option value="WY">Pine Tree (218)</Option>
                                            <Option value="WY">Pony Express (311)</Option>
                                            <Option value="WY">Potawatomi Area (651)</Option>
                                            <Option value="WY">Prairielands (117)</Option>
                                            <Option value="WY">President Gerald R. Ford FSC (781)</Option>
                                            <Option value="WY">Puerto Rico (661)</Option>
                                            <Option value="WY">Pushmataha Area (691)</Option>
                                            <Option value="WY">Quapaw Area (018)</Option>
                                            <Option value="WY">Quivira (198)</Option>
                                            <Option value="WY">Rainbow (702)</Option>
                                            <Option value="WY">Redwood Empire (041)</Option>
                                            <Option value="WY">Rio Grande (775)</Option>
                                            <Option value="WY">Rip Van Winkle (405)</Option>
                                            <Option value="WY">Rocky Mountain (063)</Option>
                                            <Option value="WY">Sagamore (162)</Option>
                                            <Option value="WY">Sam Houston Area (576)</Option>
                                            <Option value="WY">Samoset (627)</Option>
                                            <Option value="WY">San Diego-Imperial (049)</Option>
                                            <Option value="WY">San Francisco Bay Area (028)</Option>
                                            <Option value="WY">Santa Fe Trail (194)</Option>
                                            <Option value="WY">Seneca Waterways (397)</Option>
                                            <Option value="WY">Sequoia (027)</Option>
                                            <Option value="WY">Sequoyah (713)</Option>
                                            <Option value="WY">Shenandoah Area (598)</Option>
                                            <Option value="WY">Silicon Valley Monterey Bay (055)</Option>
                                            <Option value="WY">Simon Kenton (441)</Option>
                                            <Option value="WY">Sioux (733)</Option>
                                            <Option value="WY">Snake River (111)</Option>
                                            <Option value="WY">South Florida (084)</Option>
                                            <Option value="WY">South Georgia (098)</Option>
                                            <Option value="WY">South Plains (694)</Option>
                                            <Option value="WY">South Texas (577)</Option>
                                            <Option value="WY">Southeast Louisiana (214)</Option>
                                            <Option value="WY">Southern Shores FSC (783)</Option>
                                            <Option value="WY">Southern Sierra (030)</Option>
                                            <Option value="WY">Southwest Florida (088)</Option>
                                            <Option value="WY">Stonewall Jackson Area (763)</Option>
                                            <Option value="WY">Suffolk County (404)</Option>
                                            <Option value="WY">Susquehanna (533)</Option>
                                            <Option value="WY">Suwannee River Area (664)</Option>
                                            <Option value="WY">Tecumseh (439)</Option>
                                            <Option value="WY">Texas Southwest (741)</Option>
                                            <Option value="WY">Texas Trails (561)</Option>
                                            <Option value="WY">The Spirit of Adventure (227)</Option>
                                            <Option value="WY">Theodore Roosevelt (386)</Option>
                                            <Option value="WY">Three Fires (127)</Option>
                                            <Option value="WY">Three Harbors (636)</Option>
                                            <Option value="WY">Three Rivers (578)</Option>
                                            <Option value="WY">Tidewater (596)</Option>
                                            <Option value="WY">Transatlantic (802)</Option>
                                            <Option value="WY">Trapper Trails (589)</Option>
                                            <Option value="WY">Tukabatchee Area (005)</Option>
                                            <Option value="WY">Tuscarora (424)</Option>
                                            <Option value="WY">Twin Rivers (364)</Option>
                                            <Option value="WY">Twin Valley (283)</Option>
                                            <Option value="WY">Utah National Parks (591)</Option>
                                            <Option value="WY">Ventura County (057)</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Certificate Name"
                                    >
                                        <Input placeholder=" Certificate Name" />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="NESA World Explorer Date"
                                    >
                                        <DatePicker placeholder="MM/DD/YYYY" format={dateFormat} style={{width:"100%"}} />
                                        {/* <Input placeholder="Date Of Birth" /> */}
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="NESA Legacy Fellow"
                                    >
                                        <DatePicker placeholder="MM/DD/YYYY" format={dateFormat} style={{width:"100%"}} />
                                        {/* <Input placeholder="Date Of Birth" /> */}
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                <FormItem
                                        label="Current Unit Type"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Current Unit Type"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="pack">Pack</Option>
                                            <Option value="troop">Troop</Option>
                                            <Option value="team">Team</Option>
                                            <Option value="crew">Crew</Option>
                                            <Option value="ship">Ship</Option>
                                            <Option value="post">Post</Option>
                                            <Option value="lone">Lone Scout</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Current Unit Number"
                                    >
                                        <Input placeholder=" Current Unit Number" />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Current Unit City"
                                    >
                                        <Input placeholder=" Current Unit City" />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                <FormItem
                                        label="Current Unit State"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Current Unit State"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="AL">AL</Option>
                                            <Option value="AK">AK</Option>
                                            <Option value="AS">AS</Option>
                                            <Option value="AZ">AZ</Option>
                                            <Option value="AR">AR</Option>
                                            <Option value="AA">AA</Option>
                                            <Option value="AE">AE</Option>
                                            <Option value="AP">AP</Option>
                                            <Option value="CA">CA</Option>
                                            <Option value="CO">CO</Option>
                                            <Option value="CT">CT</Option>
                                            <Option value="DE">DE</Option>
                                            <Option value="DC">DC</Option>
                                            <Option value="FM">FM</Option>
                                            <Option value="FL">FL</Option>
                                            <Option value="GA">GA</Option>
                                            <Option value="GU">GU</Option>
                                            <Option value="HI">HI</Option>
                                            <Option value="ID">ID</Option>
                                            <Option value="IL">IL</Option>
                                            <Option value="IN">IN</Option>
                                            <Option value="IA">IA</Option>
                                            <Option value="KS">KS</Option>
                                            <Option value="KY">KY</Option>
                                            <Option value="LA">LA</Option>
                                            <Option value="ME">ME</Option>
                                            <Option value="MH">MH</Option>
                                            <Option value="MD">MD</Option>
                                            <Option value="MA">MA</Option>
                                            <Option value="MI">MI</Option>
                                            <Option value="MN">MN</Option>
                                            <Option value="MS">MS</Option>
                                            <Option value="MO">MO</Option>
                                            <Option value="MT">MT</Option>
                                            <Option value="NE">NE</Option>
                                            <Option value="NV">NV</Option>
                                            <Option value="NH">NH</Option>
                                            <Option value="NJ">NJ</Option>
                                            <Option value="NM">NM</Option>
                                            <Option value="NY">NY</Option>
                                            <Option value="NC">NC</Option>
                                            <Option value="ND">ND</Option>
                                            <Option value="MP">MP</Option>
                                            <Option value="OH">OH</Option>
                                            <Option value="OK">OK</Option>
                                            <Option value="OR">OR</Option>
                                            <Option value="PW">PW</Option>
                                            <Option value="PA">PA</Option>
                                            <Option value="PR">PR</Option>
                                            <Option value="RI">RI</Option>
                                            <Option value="SC">SC</Option>
                                            <Option value="SD">SD</Option>
                                            <Option value="TN">TN</Option>
                                            <Option value="TX">TX</Option>
                                            <Option value="UT">UT</Option>
                                            <Option value="VT">VT</Option>
                                            <Option value="VA">VA</Option>
                                            <Option value="VI">VI</Option>
                                            <Option value="WA">WA</Option>
                                            <Option value="WV">WV</Option>
                                            <Option value="WI">WI</Option>
                                            <Option value="WY">WY</Option>
                                            <Option value="NotUSA">Not in USA</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                <FormItem
                                        label="Camps Attended not in USA"
                                    // {...formItemLayout}
                                    >
                                         <TreeSelect
                                            showSearch
                                            style={{ width: '100%' }}
                                            value={this.state.value}
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder="Please select"
                                            allowClear
                                            multiple
                                            treeDefaultExpandAll
                                            onChange={this.onChangeMultiselect}
                                            >
                                            <TreeNode value="Alpine" title="Camp Alpine - Transatlantic (802)" key="1" />
                                            <TreeNode value="Arkadaslik" title="Camp Arkadaslik - Transatlantic (802)" key="2" />
                                            <TreeNode value="Baden-Powell" title="Camp Baden-Powell - Transatlantic (802)" key="3" />
                                            <TreeNode value="Dragon" title="Camp Dragon - Torii Beach - Far East(803)" key="4" />
                                            <TreeNode value="Freedom" title="Camp Freedom - Transatlantic (802)" key="5" />
                                            <TreeNode value="Liberty" title="Camp Liberty - Far East (803)" key="6" />
                                            <TreeNode value="Hills" title="Tama Hills Recreation Area - Far East (803)" key="7" />
                                        </TreeSelect>
                                    </FormItem>
                                </Col>
                            </Row>
                            <hr className="line-divider-full" />
                                <Row type='flex' justify='space-around'>
                                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                    <Row type='flex' justify='space-around'>
                                    <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                        <Button className="myprofile-cancel-btn" onClick={this.changeEditMode}>Cancel</Button>
                                    </Col>
                                   <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                        <Button className="save-change-btn" onClick={this.updateComponentValue} type="primary">SAVE CHANGE</Button>
                                    </Col>
                                    </Row>
                                </Col>
                                </Row>
                        </p>
                    </Form>
                </Panel>
            </Collapse>
        </div>

        )
    }

    renderDefaultView = () => {
        return (
            <div className='container'>
                <Collapse bordered={false} >
                    <Panel header={<div className="alumni-header"> <span className="myProfile-collapse-header"> Scouting Information </span>
                        <span className="editing-btn"><i class="fa fa-pencil" onClick={this.changeEditMode}></i></span>
                    </div>}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Unit Type You Most Identify with as a Youth Member </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Unit Number You Most Identify with as a Youth Member</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Unit City You Most Identify with as a Youth Member</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Unit State You Most Identify with as a Youth Member </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Current Council </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Other Council Affiliations</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Certificate Name</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>NESA World Explorer Date</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>NESA Legacy Fellow</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Current Unit Type</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Current Unit Number</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Current Unit City</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Current Unit State</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Camps Attended not in USA </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                            </Row>
                        </p>
                    </Panel>
                </Collapse>
            </div>
        )
    }


    render() {

        return this.state.isInEditMode ?
            this.renderEditView() :
            this.renderDefaultView()
    }
}

export default ScoutingInfo;


// WEBPACK FOOTER //
// ./src/components/AlumniProfile/ScoutingInfo.js